module.exports = __webpack_public_path__ + "media/images/flags/ET-c998c45d3124c0a996cc8de272bbe66e.svg";